import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getCitationInformationRpc } from '../../../../__generated__/chirp/com/hubspot/custom/enrichment/rpc/client/SmartPropertyCitationService';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export function getCitation(smartPropertyResultId) {
  return rpcClient.call(getCitationInformationRpc, {
    request: {
      smartPropertyResultId
    }
  });
}